import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ToolsApp } from './ToolsApp';
import '../styles.css';

// Entry des schlanken tools-Clients (tools.greenforce.com, P1a). Eigener
// Vite-Build (BUILD_TARGET=tools → dist/client-tools/) mit einem eigenen
// Module-Graph → nur Login + Launchpad-Platzhalter, kein DAM-/Transfer-Code.
// Prod serviert index-tools.ts das Bundle.
const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found in index-tools.html');

createRoot(rootEl).render(
  <StrictMode>
    <ToolsApp />
  </StrictMode>,
);
